/**
 * HIRO — Crossed-out "was" price in the Add to Cart CTA (site-wide)
 * -----------------------------------------------------------------
 * Shows the current price plus a faded, struck-through original price in the
 * CTA button (e.g. "ADD TO CART · £32.90 £47.00"). Helps convey the saving —
 * useful for Google Shopping / paid-traffic landing pages.
 *
 * The current price lives in `.buttonPrice` (set by Liquid, then updated by Skio
 * for subscriptions or by the theme on variant change). This script fills the
 * sibling `.buttonComparePrice` with the "was" price when there is a saving:
 *   was = max(variant.compare_at_price, variant.price)   // sale OR subscription
 *   show struck `was` only when was > current.
 *
 * The HYDRATION PDP manages its own crossed price (its quarterly plan multiplies
 * quantity, which only its selector knows), so this script bows out there.
 */
(function () {
  'use strict';
  if (document.getElementById('hy-flavs')) return; // hydration handles its own

  var section = document.querySelector('[data-product-handle]');
  var handle = section && section.getAttribute('data-product-handle');
  if (!handle) return;

  var variantsById = {};

  function parsePence(text) {
    if (!text) return null;
    var m = ('' + text).replace(/[^0-9.]/g, '');
    if (!m) return null;
    return Math.round(parseFloat(m) * 100);
  }

  // Mirror the current price's formatting (currency symbol prefix + 2 decimals).
  function formatLike(sample, pence) {
    var prefixMatch = ('' + (sample || '')).match(/^[^0-9]*/);
    var prefix = prefixMatch ? prefixMatch[0].trim() : '';
    if (!prefix) { // fall back to the shop money format symbol, default £
      var mf = (window.theme && window.theme.moneyFormat) || '£';
      var pm = mf.match(/^[^{0-9]*/);
      prefix = pm ? pm[0] : '£';
    }
    return prefix + (pence / 100).toFixed(2);
  }

  function currentVariantId(form) {
    var el = form && form.querySelector('[name="id"]');
    return el ? el.value : null;
  }

  function updateOne(priceEl) {
    var holder = priceEl.parentNode;
    var cmp = holder && holder.querySelector('.buttonComparePrice');
    if (!cmp) return;
    var form = priceEl.closest('form[action*="/cart/add"]') || document;
    var vid = currentVariantId(form);
    var v = vid && variantsById[vid];
    var now = parsePence(priceEl.textContent);
    if (!v || now == null) { return; }
    var compareAt = v.compare_at_price || 0;
    var was = Math.max(compareAt, v.price || 0);
    if (was && was > now + 1) {
      cmp.textContent = formatLike(priceEl.textContent, was);
    } else {
      cmp.textContent = '';
    }
  }

  function updateAll() {
    [].forEach.call(document.querySelectorAll('.buttonPrice'), updateOne);
  }

  // Fetch variant data once, then wire up.
  fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (product) {
      if (!product || !product.variants) return;
      product.variants.forEach(function (v) { variantsById[v.id] = v; });
      updateAll();

      // React to Skio / theme price updates (they rewrite .buttonPrice text).
      [].forEach.call(document.querySelectorAll('.buttonPrice'), function (el) {
        try {
          new MutationObserver(function () { updateOne(el); })
            .observe(el, { childList: true, characterData: true, subtree: true });
        } catch (e) {}
      });
      // React to variant changes (selected variant id changes).
      document.addEventListener('variant:changed', function () { setTimeout(updateAll, 30); });
    })
    .catch(function () {});
})();
